export { default } from './InternetDetector';
